module.exports = __webpack_public_path__ + "media/images/badges/rumble/milestone-10-Active-Rumble-bfd44506ecfbd5fc44e516f68cf3a509.png";